/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { internal_handlers_portfolio_EntryRatingInput } from './internal_handlers_portfolio_EntryRatingInput';
export type portfolio_CreatePortfolioEntryRequest = {
    body?: string;
    child_id: string;
    childcare_id: string;
    /**
     * ClientCaptureID is an OPTIONAL server-side idempotency key (issue #1102).
     *
     * A replay carrying the same key returns the ORIGINAL entry — same body,
     * same 201 — instead of writing a second one, which closes the window a
     * crash between send and ack used to leave open.
     *
     * UNIQUENESS IS PER ORGANISATION, not per author: the ledger is keyed on
     * (org_id, client_capture_id). A replay by the SAME author returns the
     * original; the same key presented by a DIFFERENT employee of that
     * organisation answers 409 PORTFOLIO_CAPTURE_KEY_CONFLICT and never that
     * author's draft, because a client-supplied key is attacker-controllable and
     * a draft is private to the employee who wrote it.
     */
    client_capture_id?: string;
    domain_ids?: Array<string>;
    group_id?: string;
    observed_at: string;
    ratings?: Array<internal_handlers_portfolio_EntryRatingInput>;
    source?: portfolio_CreatePortfolioEntryRequest.source;
    status?: portfolio_CreatePortfolioEntryRequest.status;
    subject_child_ids?: Array<string>;
    template_id?: string;
    title?: string;
};
export namespace portfolio_CreatePortfolioEntryRequest {
    export enum source {
        MANUAL = 'manual',
        VOICE = 'voice',
        GROUP = 'group',
    }
    export enum status {
        DRAFT = 'draft',
        DOCUMENTED = 'documented',
    }
}

